import get from "lodash-es/get";

export function computeFooterAggregate(
  footer: {
    value: string;
    compute_callback: string | null;
    weight_column?: string;
  },
  items: any[],
): number | string {
  if (footer.compute_callback === "avg") {
    const vals = items
      .map((item) => get(item, footer.value))
      .filter((v) => typeof v === "number");
    if (vals.length === 0) return "";
    return vals.reduce((a, b) => a + b, 0) / vals.length;
  }

  if (footer.compute_callback === "wavg") {
    const pairs = items
      .map((item) => ({
        v: get(item, footer.value),
        w: footer.weight_column ? get(item, footer.weight_column) : undefined,
      }))
      .filter(({ v, w }) => typeof v === "number" && typeof w === "number");
    if (pairs.length === 0) return "";
    const totalWeight = pairs.reduce((a, { w }) => a + w, 0);
    if (totalWeight === 0) return "";
    return pairs.reduce((a, { v, w }) => a + v * w, 0) / totalWeight;
  }

  // 'sum' and any other callback — sum all numeric values
  return items
    .map((item) => get(item, footer.value))
    .filter((v) => typeof v === "number")
    .reduce((a, b) => a + b, 0);
}
